/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Keen_Lynx_LeapInputs */

const en_wide_keen_lynx_leap = /** @type {(inputs: Wide_Keen_Lynx_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version restored successfully`)
};

const de_wide_keen_lynx_leap = /** @type {(inputs: Wide_Keen_Lynx_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version erfolgreich wiederhergestellt`)
};

/**
* | output |
* | --- |
* | "Version restored successfully" |
*
* @param {Wide_Keen_Lynx_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_keen_lynx_leap = /** @type {((inputs?: Wide_Keen_Lynx_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Keen_Lynx_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_keen_lynx_leap(inputs)
	return de_wide_keen_lynx_leap(inputs)
});